import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../../constants/colors';
import { fontSize } from '../../../../../../constants/text';
import { breakpoints } from '../../../../../../core/util/styledComponents';

const Root = styled.div.withConfig({ componentId: 'sc-1mxaoy3-0' })`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid
    ${(props) =>
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
      props.sc && props.sc.isSelected ? colors.gray600 : colors.lightText};
  background-color: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    props.sc && props.sc.isSelected ? colors.gray200 : 'none'};
  border-radius: 4px;
  width: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    props.sc && props.sc.width};
  min-height: 45px;
  font-size: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    props.sc && props.sc.fontSize};
  font-weight: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    props.sc && props.sc.isSelected ? 'bold' : 'normal'};
  color: ${colors.squid};
  cursor: pointer;
  @media (width: ${breakpoints.mdLg}) {
    font-size: ${fontSize.mediumSmall};
  }
`;

const IconTitleContainer = styled.div.withConfig({ componentId: 'sc-1mxaoy3-1' })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  margin: 0 auto;
`;

const Icon = styled.img.withConfig({ componentId: 'sc-1mxaoy3-2' })`
  width: 18px;
  margin: 0 10px 0 5px;
`;

type OwnProps = {
  fontSize?: string;
  icon?: string;
  isSelected?: boolean;
  onClick: (...args: any[]) => any;
  title: any | string;
  width: string;
  dataTestId?: string;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof ToggleButton.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'ToggleButton' implicitly has type 'any' because i... Remove this comment to see the full error message
const ToggleButton = ({ fontSize, icon, isSelected, onClick, title, width, dataTestId }: Props) => (
  // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type 'IntrinsicAtt... Remove this comment to see the full error message
  <Root data-testid={dataTestId} onClick={onClick} sc={{ fontSize, isSelected, width }}>
    <IconTitleContainer>
      {icon && <Icon src={icon} />}

      <div>{title}</div>
    </IconTitleContainer>
  </Root>
);

ToggleButton.defaultProps = {
  fontSize: fontSize.default,
};

export default ToggleButton;
